import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { App } from './pages'
import store from './store'
import { Provider } from 'react-redux'
import Firebase, { FirebaseProvider } from './components/Firebase'
import { ThemeProvider } from '@material-ui/core/styles'
import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import * as serviceWorker from './serviceWorker'
import { main } from './services/theme'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import network from './services/api'
import { applyEnvironmentFavicon } from './utils/environment'

const history = createBrowserHistory()
network.setupInterceptors(store, history)
applyEnvironmentFavicon()

ReactDOM.render(
	<ThemeProvider theme={main}>
		<Provider store={store}>
			<MuiPickersUtilsProvider utils={MomentUtils}>
				<FirebaseProvider value={Firebase}>
					<Router history={history}>
						<App firebase={Firebase} />
					</Router>
				</FirebaseProvider>
			</MuiPickersUtilsProvider>
		</Provider>
	</ThemeProvider>,
	document.getElementById('root')
)
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
